'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeFunnelareaIcon = function TraceTypeFunnelareaIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 60 60' }, props),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M18.2 35.4l-5.6-10.8h34.8l-5.7 10.8H18.2z' }),
        _react2.default.createElement('path', { fill: '#0083d3', d: 'M24.2 48l-5.5-10.8h22.6L35.8 48H24.2z' }),
        _react2.default.createElement('path', { fill: '#09ffff', d: 'M12.2 22.8L6.5 12h47l-5.6 10.8H12.2z' })
    );
};

exports.default = TraceTypeFunnelareaIcon;